// https://github.com/bluelovers/ws-string/blob/master/packages/crlf-normalize/src/index.ts
const R_CRLF = /\r\n|\r(?!\n)|\n/g;
const CRLF = '\r\n';
const crlfNormalize = text => text.replace(R_CRLF, CRLF);

export default crlfNormalize;
